import { render, staticRenderFns } from "./VipCenter copy.vue?vue&type=template&id=a7b82df6&scoped=true"
import script from "./VipCenter copy.vue?vue&type=script&lang=js"
export * from "./VipCenter copy.vue?vue&type=script&lang=js"
import style0 from "./VipCenter copy.vue?vue&type=style&index=0&id=a7b82df6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7b82df6",
  null
  
)

export default component.exports